<template>
  <div v-if="!item.hidden">
    <template v-if="hasOneShowingChild(item.children,item)&& (!onlyOneChild.children||onlyOneChild.noShowingChildren)" >
      <router-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)" style="text-decoration: none;">
        <el-menu-item :index="resolvePath(onlyOneChild.path)">{{ onlyOneChild.meta.title }}</el-menu-item>
      </router-link>
    </template>
    
    <el-submenu  v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title" v-if="item.meta">{{ item.meta.title }}</template>
      <menu-item
        v-for="child in item.children"
        :key="child.path"
        :item="child"
        :base-path="resolvePath(child.path)"
      />
    </el-submenu>
  </div>

</template>
 
<script>
import path from 'path'
import { isExternal } from '@/utils/validate'

export default {
  name: 'MenuItem', 
  props: {
    item: {
      type: Object,
      required: true
    },
    basePath: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      onlyOneChild: null,
    };
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false;
        } else {
          this.onlyOneChild = item;
          return true;
        }
      });
      
      if (showingChildren.length === 1) {
        return true;
      }
      if (showingChildren.length === 0) {
          this.onlyOneChild = { ... parent, path: '', noShowingChildren: true };
          return true;
      }
      return false;
    },
    resolvePath(routePath) {
      if(isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      return path.resolve(this.basePath,routePath)
    }
  },
}
</script>




// WEBPACK FOOTER //
// src/layout/components/NavBar/MenuItem.vue